import React, { useEffect, useState } from "react";
import { getLeaderboard } from "../../api/ideas";

/**
 * Боковая колонка «Топ авторов года». Загружается лениво
 * (не блокирует основной контент главной /ideas).
 */
export default function IdeaLeaderboard({ period = "year", limit = 5 }) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    const ctl = new AbortController();
    getLeaderboard({ period, limit, signal: ctl.signal })
      .then((d) => setData(d.items || []))
      .catch((e) => {
        if (e.name !== "AbortError") setErr(e.message);
      });
    return () => ctl.abort();
  }, [period, limit]);

  if (err) return null;
  if (!data) return <div className="idz-loading">Загрузка…</div>;
  if (data.length === 0)
    return <div className="idz-hint">Пока нет авторов</div>;

  return (
    <div className="idz-lb">
      {data.map((r, i) => (
        <div key={r.author_id} className={`idz-lb-item r${i + 1}`}>
          <span className="idz-lb-rank">{i + 1}</span>
          <span className="idz-lb-name">
            {r.author_name || `#${r.author_id}`}
          </span>
          <span className="idz-lb-meta">
            {r.ideas_count} идей · {r.likes_total} лайков
          </span>
        </div>
      ))}
    </div>
  );
}
